// Datos ficticios de ejemplo — plantilla "Lumina" (15 años).
// Contrato neutral: protagonista en lugar de pareja; el resto de campos son comunes.

export const datosEjemplo = {
  tipoEvento: "quince",
  plantillaId: "quince-lumina",

  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "La cuenta regresiva", titulo: "Cada vez más cerca", textoFinalizado: "¡Hoy es la noche!" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "Dónde y cuándo", titulo: "La noche de mis quince" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agendalo", titulo: "Reservá la fecha" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Mis momentos", titulo: "Un adelanto de esta historia" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "El programa", titulo: "Cómo va a ser la noche" },
    { id: "menciones", visible: true, orden: 6, etiqueta: "Mis pilares", titulo: "Quienes me acompañan" },
    { id: "video", visible: true, orden: 7, etiqueta: "Mi video", titulo: "Quince años en un minuto" },
    { id: "musica", visible: true, orden: 8, etiqueta: "La playlist", titulo: "Lo que va a sonar" },
    { id: "regalos", visible: true, orden: 9, etiqueta: "Mesa de regalos", titulo: "Con cariño, si querés" },
    { id: "rsvp", visible: true, orden: 10, etiqueta: "Confirmación", titulo: "¿Venís a mi fiesta?" },
    { id: "enlaces", visible: true, orden: 11, etiqueta: "Datos útiles", titulo: "Información adicional" },
    { id: "accesos", visible: true, orden: 12, etiqueta: "Participá", titulo: "Dejame tu huella" },
    { id: "cierre", visible: true, orden: 13 },
  ],

  protagonista: {
    nombre: "Valentina",
    fraseIntroductoria: "Mis XV años",
    mensajePortada:
      "Quiero celebrar esta noche soñada junto a las personas que más quiero.",
    mensajeCierre:
      "Gracias por acompañarme en la noche más importante de mis quince. Te espero para brillar juntos.",
    textoBotonEntrada: "Ver la invitación",
  },

  evento: {
    fechaISO: "2026-12-12T20:00:00-03:00",
    fechaLegible: "Sábado 12 de diciembre de 2026",
    fechaCorta: "12 · 12 · 2026",
    ciudad: "Luque, Paraguay",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1517841905240-472988babdf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Valentina sonriendo al aire libre",
      },
      {
        src: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Retrato de Valentina con luz suave",
      },
      {
        src: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Valentina con vestido de fiesta",
      },
      {
        src: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Retrato de estudio de Valentina",
      },
    ],
  },

  eventos: [
    {
      id: "misa",
      etiqueta: "Misa de acción de gracias",
      lugar: "Parroquia Virgen del Rosario",
      direccion: "Centro de Luque, a metros de la Plaza de los Héroes",
      horario: "19:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Parroquia+Virgen+del+Rosario+Luque+Paraguay",
      textoBoton: "Cómo llegar",
    },
    {
      id: "fiesta",
      etiqueta: "Recepción y fiesta",
      lugar: "Salón de Eventos Valle Yvoty",
      direccion: "Ruta Luque–San Bernardino km 24, Luque",
      horario: "21:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Luque+Paraguay",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "XV años de Valentina",
    descripcion: "Misa 19:00 h en Parroquia Virgen del Rosario y fiesta 21:00 h en Salón Valle Yvoty.",
    texto: "Sábado 12 de diciembre de 2026 · Luque, Paraguay. Agendá la fecha y vení a celebrar.",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2026-12-12T19:00:00-03:00",
    finISO: "2026-12-13T03:00:00-03:00",
    ubicacion: "Parroquia Virgen del Rosario, Luque, Paraguay",
  },

  itinerario: [
    { hora: "19:00", titulo: "Misa", descripcion: "Ceremonia de acción de gracias.", icono: "iglesia" },
    { hora: "21:00", titulo: "Ingreso y vals", descripcion: "El momento más esperado de la noche.", icono: "musica" },
    { hora: "21:45", titulo: "Cena", descripcion: "Menú de tres pasos con opción vegetariana.", icono: "cena" },
    { hora: "23:00", titulo: "Show sorpresa", descripcion: "Preparate para bailar.", icono: "brillo" },
    { hora: "00:00", titulo: "Hora loca", descripcion: "Cotillón y pista abierta.", icono: "fiesta" },
    { hora: "02:30", titulo: "Cierre", descripcion: "Último brindis de la noche.", icono: "corazon" },
  ],

  menciones: [
    {
      nombre: "Lorena Duarte",
      rol: "Mamá",
      foto: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Fabián Duarte",
      rol: "Papá",
      foto: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Carolina Ríos",
      rol: "Madrina",
      foto: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Andrés Vera",
      rol: "Padrino",
      foto: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
  ],

  video: {
    urlYoutube: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },

  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    nota: "Dale play cuando quieras. La música nunca arranca sola.",
  },

  regalos: {
    mensaje: "Compartir esta noche conmigo ya es un regalo. Si querés tener un detalle, estas son mis mesas.",
    tiendas: [
      {
        nombre: "Casa Victoria",
        url: "https://www.google.com/maps/search/?api=1&query=mesa+de+regalos+Asunci%C3%B3n",
        nota: "Mesa de regalos · Valentina",
      },
      {
        nombre: "Box Regalos",
        url: "https://www.instagram.com",
        nota: "Lista «Mis XV Valen»",
      },
    ],
    alternativa: {
      titulo: "Lluvia de sobres",
      texto: "habrá una cajita junto al libro de firmas.",
    },
  },

  rsvp: {
    mensaje:
      "Tu presencia es el mejor regalo. Confirmame tu asistencia para reservarte un lugar en mi mesa.",
    textoBoton: "Confirmar asistencia",
    fechaLimite: "Por favor confirmá antes del 12 de noviembre de 2026",
  },

  enlaces: [
    { texto: "Inspiración de looks", url: "https://www.pinterest.com" },
    { texto: "#LosXVDeValen", url: "https://www.instagram.com" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Libro de firmas",
      texto: "Dejame un mensaje para este día tan especial.",
    },
    album: {
      titulo: "Álbum colaborativo",
      texto: "Sumá tus fotos y videos de la fiesta.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Hecho con amor · Pro360 Invitaciones Digitales Plus",
  },
};
